export default __webpack_public_path__ + "static/media/axa_favicon.b0e8c95c.ico";